import Resource, {BaseResource} from './Resource';

/**
 * User Resource
 */
class User extends Resource
{
    constructor() {
        super('account.user', ['users']);
    }

    me(params = {}) {
        return this._doGet(['me'], params);
    }

    status(params = {}) {
        return this._doGet(['me', 'status'], params);
    }

    updateMe(data, params = {}, config = {}) {
        return this._doPost(['me'], data, params, config);
    }

    sendIntrayUploadLink(data, params = {}, config = {}) {
        return this._doPost(['me', 'intray-upload-notification'], data, params, config);
    }

    removeAvatar(params = {}) {
        return this._doDelete(['me', 'avatar'], params);
    }

    supportCodeStatus() {
        return this._doGet(['me', 'support-code'])
    }

    grantSupportCode() {
        return this._doPost(['me', 'support-code', 'grant'])
    }

    revokeSupportCode() {
        return this._doPost(['me', 'support-code', 'revoke'])
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}   
export let UserResource = new User();

export let UserSchema = function(defaults = {}) {
    let schema = {
        id: null,
        first_name: null, 
        last_name: null,
        email: null, 
        secondary_email: null,
        mobile_number: null,
        avatar_type: 'initials',
        password: null, 
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let TeamSchema = function(defaults = {}) {
    let schema = {
        id: null,
        name: null, 
        type: null, 
        location: null,
        location_id: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

/**
 * Notifications Resource
 */
class Notifications extends BaseResource
{
    constructor() {
        super()
        this.handle = 'account.user.notifications'
        this.resourceSegments = ['users', 'me', 'notifications'];
    }

    all(params = []) {
        return this._doGet([], params);
    }

    markAllSeen() {
        return this._doPut(['mark-all-seen'])
    }

    markAllRead() {
        return this._doPut(['mark-all-read'])
    }

    destroyAll() {
        return this._doDelete([])
    }

    markRead(notification_id) {
        return this._doPut([notification_id, 'mark-read'])
    }

    markUnread(notification_id) {
        return this._doPut([notification_id, 'mark-unread'])
    }

    destroy(notification_id) {
        return this._doDelete([notification_id])
    }
}

export let NotificationsResource = new Notifications();

export let TeamTypes = {
    SALES:'sales',
    WORKSHOP:'workshop',
    BODYSHOP:'bodyshop',
    ACCOUNTS:'accounts',
    VALETING: 'valeting',
}
